export default "__VITE_ASSET__C6$F407T__"